import { Pipe, PipeTransform } from '@angular/core';
import { InventoryItemState } from '@app/shared/enums/InventoryItemState.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'inventoryItemState',
    standalone: false
})
export class InventoryItemStatePipe implements PipeTransform {
  public itemStates = InventoryItemState;
  public inventoryItemsList: any[] = [];

  constructor(public translate: TranslateService) { }

  transform(value: any): string {
    if (!value) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = states
      .map(state => {
        const key = Object.keys(InventoryItemState).find(
          k => InventoryItemState[k as keyof typeof InventoryItemState] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.inventoryItemsList = [];

    for (const [propertyKey, propertyValue] of Object.entries(InventoryItemState)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }

      this.inventoryItemsList.push({ id: !!propertyValue, name: this.translate.instant('ENUMS.' + propertyKey) });
    }

    return this.inventoryItemsList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(InventoryItemState)) {
      if (propertyValue == Id) {
        return { id: propertyValue, name: this.translate.instant('ENUMS.' + propertyKey) };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(InventoryItemState)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
